(function () {
    'use strict';

    angular
        .module('app')
        .directive('componentImageGallery', componentImageGallery);

    componentImageGallery.$inject = ['$window'];

    function componentImageGallery($window) {
        // Usage:
        //     <componentImageGallery></componentImageGallery>
        // Creates:
        // 
        var directive = {
            restrict: 'EA',
            scope: {
                instance: "@instance"
            },
            link: link
        };
        return directive;

        function link(scope) {
            // Create a lightbox
            (function () {
                var $instance = scope.instance;
                var $lightbox = $("<div class='lightbox " + $instance +"' id='img-grid'></div>");
                var $prevButton = $("<button class='prev hide-mobile'><img src= '/Static/Common/images/arrow-l.png' alt= 'Arrow Left - Previous'/></button >");
                var $nextButton = $("<button class='next hide-mobile'><img src= '/Static/Common/images/arrow-r.png' alt= 'Arrow Right - Next'/></button >");
                var $lightboxImgDiv = $("<div id='lightbox-img' class='"+ $instance +"'></div>");
                var $img = $("<img>");
                var $caption = $("<p class='caption'></p>");

                // Add image and caption to lightbox
                $lightboxImgDiv
                    .append($prevButton)
                    .append($img)
                    .append($nextButton);
                $lightbox
                    .append($lightboxImgDiv)
                    .append($caption);

                // Add lighbox to document
                if ($('#img-grid.'+$instance).length === 0)
                    $('body').append($lightbox);

                $('.lightbox-gallery.' + $instance + ' img').click(function (e) {
                    e.preventDefault();

                    //set parent div class to active
                    var $parent = $(this).parent('div');
                    $parent.addClass("active");

                    addToLightbox($(this));

                    $lightbox.click(function () {
                        $('.lightbox-gallery.' + $instance).find('.active').removeClass("active");
                        $lightbox.fadeOut('fast');
                    });
                });
                
                //change slide to next image
                $("#lightbox-img." + $instance).find(".next").on("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    var galleryImg = $(".lightbox-gallery." + $instance).find(".active");
                    var next = galleryImg.next();

                    if (next.length) {
                        galleryImg.removeClass("active");
                        next.addClass("active");

                        // Get image link and description
                        var nextImg = next.find("img");
                        addToLightbox(nextImg);
                    }
                });

                //change slide to previous image
                $("#lightbox-img." + $instance).find(".prev").on("click", function (e) {
                    e.stopPropagation();
                    e.preventDefault();

                    var galleryImg = $(".lightbox-gallery." + $instance).find(".active");
                    var prev = galleryImg.prev();

                    if (prev.length) {
                        galleryImg.removeClass("active");
                        prev.addClass("active");

                        // Get image link and description
                        var prevImg = prev.find("img");
                        addToLightbox(prevImg);
                    }
                });

                function addToLightbox(obj) {
                    // Get image link and description                    
                    var src = obj.attr("src");
                    var cap = obj.attr("alt");

                    // Add data to lighbox

                    $img.attr('src', src);
                    $caption.text(cap);

                    // Show lightbox
                    $lightbox.fadeIn('fast');
                }

                //set flex-basis depending on the number of child elements
                var $lightboxGalleryDiv = $('.lightbox-gallery.' + $instance + ' div');

                var numImages = $lightboxGalleryDiv.length;
                if (numImages > 16)
                    $lightboxGalleryDiv.css("flex-basis", "20%");
                else if (numImages <= 16 && numImages > 12)
                    $lightboxGalleryDiv.css("flex-basis", "25%");
                else if (numImages <= 12)
                    $lightboxGalleryDiv.css("flex-basis", "33.33%");
            }());
        }
    }
})();



//////////////////
// WEBPACK FOOTER
// ./Views/Blocks/ImageGridBlock/_componentImageGallery.js
// module id = 26
// module chunks = 0